import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './OrphanView.scss';
var OrphanView = function () {
    var t = useTranslation().t;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['orphan-header'] }, t('comment.orphaned.header')),
        React.createElement("div", { className: s['orphan-subheader'] }, t('comment.orphaned.subheader'))));
};
OrphanView.displayName = 'OrphanView';
export default OrphanView;
//# sourceMappingURL=OrphanView.js.map